import { render, staticRenderFns } from "./ProjectRegister.vue?vue&type=template&id=2d90243b&scoped=true&"
import script from "./ProjectRegister.vue?vue&type=script&lang=js&"
export * from "./ProjectRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90243b",
  null
  
)

export default component.exports